import React from "react";
import createReactClass from "create-react-class";

import ModalAlert from "../modal/modal_alert";

export default createReactClass({
  displayName: "Root",
  handleSendCurrentEmailConfirmation: function() {
    $.ajax({
      url: "/api/user/send_current_email_confirm",
      type: "POST",
      headers: {
        "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content,
      },
      cache: false,
    })
      .done(
        function() {
          // success
          this.modalAlertSendingSuccess.openModal();
        }.bind(this)
      )
      .fail(
        function() {
          // error
          this.modalAlertSendingError.openModal();
        }.bind(this)
      );
  },
  render() {
    return (
      <div className="container col-md-8 col-lg-6">
        <div className="bg-white panel panel-warning p-3 my-4 rounded">
          <div className="panel-heading">
            <h3 className="text-center text-fz-18px ">
              <img src="/assets2019/img/envelope.png" style={{width: '20px'}} />{' '}
              メールアドレスが使えません
            </h3>
          </div>
          <div className="panel-body pt-4 text-fz-11px">
            <p>お使いのメールアドレスは、メールが届かないため使用できません。</p>
            <p>
              メールアドレスを変更するか、メールアドレスを変更しない場合は、info@tunagate.com
              からの受信が可能な状態にして、<a
                style={{ color: "#2292a4" }}
                onClick={this.handleSendCurrentEmailConfirmation}
              >
                こちらから確認メールの送信を行い
              </a>、受信したメールのリンクをクリックしてください。
            </p>
          </div>
        </div>

        <ModalAlert
          ref={(c) => {
            this.modalAlertSendingSuccess = c;
          }}
          title="送信完了"
          content="お使いのメールアドレス宛に確認のメールを送信しました。ご確認ください。"
        />

        <ModalAlert
          ref={(c) => {
            this.modalAlertSendingError = c;
          }}
          title="エラー"
          content="確認のメールを送信できませんでした。しばらく経ってから再度お試しください。"
        />
      </div>
    );
  },
});
